import { UrgencyIdField, RadioButtonField, SelectIdField } from '~fields';
import { usePatientRooms } from '~hooks/usePatientRooms';

const SeparateBedFields = () => {
  const patientRooms = usePatientRooms();
  const patientRoomOptions = patientRooms.map(room => ({
    label: room.clinicalName,
    value: room.id,
  }));

  return (
    <>
      <SelectIdField name="nearestRoom" options={patientRoomOptions} required />

      <UrgencyIdField name="urgency" required />

      <RadioButtonField name="plasticWrap" flat firstElementMinWidth="150px" />
    </>
  );
};

export default SeparateBedFields;
